<template>
  <div class="container">
    <div class="box">
      <div class="is-flex is-flex-direction-column flex-gap-10">
        <div class="columns">
          <div class="column">
            <!--<b-field label="Date Range" horizontal><b-datepicker v-model="dates" range @input="GetData()"></b-datepicker></b-field>-->
            <b-field label="Date Range" horizontal
              ><date-range-picker
                ref="picker"
                :opens="'right'"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :minDate="'06-01-2022'"
                :maxDate="dayjs().subtract(1, 'days').format('MM-DD-YYYY')"
                :singleDatePicker="false"
                :timePicker="false"
                :timePicker24Hour="false"
                :showWeekNumbers="true"
                :showDropdowns="true"
                :showRanges="true"
                :autoApply="true"
                v-model="dateRange"
                :linkedCalendars="false"
                @finish-selection="GetDailyData()"
                @select="GetDailyData()"
              >
                <div slot="header" class="slot">
                  <div class="box has-background-primary date-selection-header">
                    <h3 class="title is-size-5">Range Selection</h3>
                    <p class="subtitle is-size-7">Please select two dates, or choose one to the left</p>
                  </div>
                </div>
              </date-range-picker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Region" horizontal
              ><b-select v-model="selected_region" @input="GetDailyData()">
                <option v-for="region in Regions" :key="region">{{ region }}</option>
              </b-select></b-field
            >
            <b-field label="Customer" horizontal
              ><b-select v-model="selected_customer" @input="GetDailyData()">
                <option v-for="customer in CustomerList" :key="customer.id" :value="customer">{{ customer.CustomerFriendlyName }}</option>
              </b-select></b-field
            >
            <!--<b-field><b-autocomplete v-model="selected_customer_name" open-on-focus :data="customerList" @input="(option) => (selected_customer = option)" append-to-body></b-autocomplete></b-field>-->
          </div>
        </div>
        <div class="is-flex flex-gap-10">
          <b-button type="is-primary" @click="GetDailyData()">Submit</b-button>
          <template v-if="loaded">
            <download-csv
              class="button is-success"
              v-if="hasIcabbiAccess"
              :data="exportData"
              :name="'VoicePlusBilling - ' + dayjs(dateRange.startDate).format('DD-MM-YYYY') + '-' + dayjs(dateRange.endDate).format('DD-MM-YYYY') + '.csv'"
              >Export All</download-csv
            >
          </template>
          <b-dropdown v-model="viewingColumnList" v-if="hasIcabbiAccess" multiple
            ><template #trigger
              ><b-button type="is-warning" icon-right="menu-down">Selected Columns ({{ viewingColumnList.length }})</b-button></template
            >
            <b-dropdown-item v-for="column in columnList" :key="column.name" :value="column.field">
              <span>{{ column.name }}</span>
            </b-dropdown-item></b-dropdown
          >
        </div>
      </div>
    </div>
    <template v-if="loaded">
      <template v-for="(reseller, key) in billingData">
        <div class="box" :key="key" v-if="UserHasAccess(key) && reseller.data.length > 0">
          <div class="level">
            <div class="level-left">
              <div class="title is-size-5">{{ reseller.title }}</div>
            </div>
            <div class="level-right">
              <template v-if="loaded">
                <download-csv
                  class="button is-success"
                  :data="reseller.exportData"
                  :name="key + ' - VoicePlusBilling - ' + dayjs(dateRange.startDate).format('DD-MM-YYYY') + '-' + dayjs(dateRange.endDate).format('DD-MM-YYYY') + '.csv'"
                  >Export Section</download-csv
                >
              </template>
            </div>
          </div>
          <div class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Customers</p>
                <p class="title">{{ reseller.data.length | commaSeperators }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Sessions</p>
                <p class="title">{{ reseller.totals.bookableSessions | commaSeperators }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Chargeable</p>
                <p class="title">{{ reseller.totals.chargeableCalls | commaSeperators }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Fixed Location</p>
                <p class="title">{{ reseller.totals.fixedLocCalls | commaSeperators }}</p>
              </div>
            </div>
          </div>
          <b-table :data="reseller.data" :loading="isLoading" hoverable detail-key="customerInfo" sticky-header>
            <b-table-column field="customerInfo.uuid" label="UID" sortable v-if="viewingColumnList.includes('customerInfo.uuid')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Provided by the finance team" dashed position="is-right" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.customerInfo.uuid }}
              </template>
            </b-table-column>
            <b-table-column field="customerInfo.customer_name" label="Customer" v-slot="props" sortable v-if="viewingColumnList.includes('customerInfo.customer_name')"
              >{{ props.row.customerInfo.customer_name }}
            </b-table-column>
            <b-table-column field="paid.bookableSessions" label="Sessions" sortable v-if="viewingColumnList.includes('paid.bookableSessions')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Calls which have passed through Voice+" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ (props.row.paid.bookableSessions + props.row.trial.bookableSessions) | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="paid.chargeableCalls" label="Chargeable Sessions" sortable v-if="viewingColumnList.includes('paid.chargeableCalls')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Calls which have passed through Voice+ and have chargable outcomes" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.paid.chargeableCalls | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="paid.fixedLocCalls" label="F/L Sessions" sortable v-if="viewingColumnList.includes('paid.fixedLocCalls')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Calls from fixed locations" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.paid.fixedLocCalls | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="trial.chargeableCalls" label="Trial Sessions" sortable v-if="viewingColumnList.includes('trial.chargeableCalls')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Calls made during trial" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.trial.chargeableCalls | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="trial.fixedLocCalls" label="Trial Fixed locations" sortable v-if="viewingColumnList.includes('trial.fixedLocCalls')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Fixed location calls made during trial" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.trial.fixedLocCalls | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="usage.recogSeconds" label="Recognition Usage" sortable v-if="viewingColumnList.includes('usage.recogSeconds')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Amount of recognition used (Days, Hours, Minutes, Seconds)" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage.recogSeconds | secondDivider }}
              </template>
            </b-table-column>
            <b-table-column field="usage.enhancedRecogSeconds" label="Enhanced Recognition Usage" sortable v-if="viewingColumnList.includes('usage.enhancedRecogSeconds')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Amount of enhanced recognition used (Days, Hours, Minutes, Seconds)" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage.enhancedRecogSeconds | secondDivider }}
              </template>
            </b-table-column>
            <b-table-column field="usage.google-geocode" label="Google geocode requests" sortable v-if="viewingColumnList.includes('usage.google-geocode')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Number of times a geocode lookup was performed" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage["google-geocode"] | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="usage.google-autocomplete" label="Google autocomplete requests" sortable v-if="viewingColumnList.includes('usage.google-autocomplete')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Number of times a autocomplete lookup was performed" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage["google-autocomplete"] | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="usage.google-placesfromtext" label="Google places requests" sortable v-if="viewingColumnList.includes('usage.google-placesfromtext')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Number of times a places from text lookup was performed" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage["google-placesfromtext"] | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="usage.icabbi-search" label="icabbi search requests" sortable v-if="viewingColumnList.includes('usage.icabbi-search')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Number of times a icabbi address lookup was performed" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage["icabbi-search"] | commaSeperators }}
              </template>
            </b-table-column>
            <b-table-column field="usage.failover" label="Voice+ as Failover" sortable v-if="viewingColumnList.includes('usage.failover')">
              <template v-slot:header="{ column }">
                <b-tooltip label="Number of times a icabbi a call hit V+ as failover" dashed position="is-bottom" append-to-body>{{ column.label }}</b-tooltip>
              </template>
              <template v-slot="props">
                {{ props.row.usage["failover"] | commaSeperators }}
              </template>
            </b-table-column>
          </b-table>
        </div>
      </template>
    </template>
    <template v-if="isLoading">
      <div class="box">
        <div class="is-flex is-flex-direction-column is-align-items-center">
          <loading-spinner></loading-spinner>
          <div class="title is-size-5">Generating Report</div>
          <div class="subtitle is-size-6 has-text-grey">This may take a while based on specified parameters</div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.tile.is-parent {
  gap: 15px;
}

.content {
  width: 100%;
}

.container {
  margin: 20px auto 20px auto;
}

.buttonWrap {
  grid-column: 1/3;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}
</style>
<style scoped>
span.select {
  width: 100%;
}

select {
  width: 100%;
}
</style>

<script>
import LoadingSpinner from "../../../components/common/LoadingSpinner.vue";
const axios = require("axios");
const downloadCsv = require("vue-json-csv");
import dayjs from "dayjs";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const customParseFormat = require("dayjs/plugin/customParseFormat");
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  components: {
    downloadCsv,
    LoadingSpinner,
    DateRangePicker,
  },
  data: function () {
    return {
      newApiUrl: "https://api.jeak.co.uk",
      exchangeRateApiKey: process.env.VUE_APP_EXCHANGE_RATE_API_KEY || "",
      billingData: {
        etgl: { title: "Exel Technology Group", data: [], exportData: [], totals: { bookableSessions: 0, chargeableCalls: 0, fixedLocCalls: 0 } },
        icabbi: { title: "iCabbi", data: [], exportData: [], totals: { bookableSessions: 0, chargeableCalls: 0, fixedLocCalls: 0 } },
      },
      columnList: [
        { name: "uuid", field: "customerInfo.uuid" },
        { name: "Customer Name", field: "customerInfo.customer_name" },
        { name: "Total Calls", field: "paid.bookableSessions" },
        { name: "Chargeable Calls", field: "paid.chargeableCalls" },
        { name: "Fixed Location Calls", field: "paid.fixedLocCalls" },
        { name: "Trial Chargeable Calls", field: "trial.chargeableCalls" },
        { name: "Trial Fixed Location Calls", field: "trial.fixedLocCalls" },
        { name: "Recognition Used", field: "usage.recogSeconds" },
        { name: "Enhanced Recognition Used", field: "usage.enhancedRecogSeconds" },
        { name: "Google Geocode Requests", field: "usage.google-geocode" },
        { name: "Google autocomplete Requests", field: "usage.google-autocomplete" },
        { name: "Google places from text Requests", field: "usage.google-placesfromtext" },
        { name: "icabbi search Requests", field: "usage.icabbi-search" },
        { name: "V+ as failover", field: "usage.failover" },
      ],
      viewingColumnList: ["customerInfo.uuid", "customerInfo.customer_name", "paid.bookableSessions", "paid.chargeableCalls", "paid.fixedLocCalls", "trial.chargeableCalls"],
      dayjs: dayjs,
      loaded: false,
      dateRange: {},
      dailyApiData: [],
      exportData: [],
      selected_region: "All Regions",
      selected_customer: { id: -1, CustomerFriendlyName: "All Customers" },
      selected_customer_name: "",
      selected_currency: "USD",
      allCustomers: [],
      customers: [],
      currencies: [],
      usage_outcomes: ["recogSeconds", "enhancedRecogSeconds", "google-autocomplete", "google-geocode", "google-placesfromtext", "icabbi-search"],
      requestSequence: 0,
      currency_symbols: {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
        CAD: "$", // Canadian Dollar
        AUD: "$", // Australian Dollar,
        RUB: "₽",
      },
      isLoading: false,
      customer_data: [],
    };
  },
  methods: {
    dateFormatter(dt) {
      return dayjs(dt).format();
    },
    GetTags: async function() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      let from = dayjs(this.dateRange["startDate"]).format("YYYY-MM-DD");
      let to = dayjs(this.dateRange["endDate"]).format("YYYY-MM-DD");
      const response = await axios.get(this.newApiUrl + `/stats/booking-tags?dateFrom=${from}&dateTo=${to}`, config);

     return response.data;

    },
    GetDailyData: async function () {
      const requestId = ++this.requestSequence;
      this.loaded = false;
      this.isLoading = true;
      try {
        const hasDateRange = this.dateRange && this.dateRange.startDate && this.dateRange.endDate;
        if (!hasDateRange) {
          const defaultEndDate = dayjs().subtract(1, "day").endOf("day").toDate();
          const defaultStartDate = dayjs(defaultEndDate).subtract(6, "day").startOf("day").toDate();
          this.dateRange = { startDate: defaultStartDate, endDate: defaultEndDate };
        }

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        const from = dayjs(this.dateRange["startDate"]).format("YYYY-MM-DD");
        const to = dayjs(this.dateRange["endDate"]).format("YYYY-MM-DD");
        const response = await axios.get(this.newApiUrl + `/stats/customer/outcomes?from=${from}&to=${to}`, config);

        const nextDailyApiData = [];
        for (const [key, value] of Object.entries(response.data)) {
          let tmpObj = { date: dayjs(key).format("DD-MM-YYYY"), value: {} };
          for (const [customerId, customerData] of Object.entries(value)) {
            if (this.selected_region != "All Regions" && this.selected_customer.id > 0) {
              if (customerId == this.selected_customer.id) {
                tmpObj.value[customerId] = customerData;
              }
            } else if (this.selected_region != "All Regions") {
              let foundCustomer = this.allCustomers.find((customerSearch) => {
                return customerSearch.id == customerId;
              });
              if (foundCustomer && foundCustomer.billing_region == this.selected_region) {
                tmpObj.value[customerId] = customerData;
              }
            } else if (this.selected_customer.id > 0) {
              if (customerId == this.selected_customer.id) {
                tmpObj.value[customerId] = customerData;
              }
            } else {
              tmpObj.value[customerId] = customerData;
            }
          }
          nextDailyApiData.push(tmpObj);
        }

        if (requestId !== this.requestSequence) return;
        this.dailyApiData = nextDailyApiData;
        await this.FormatData(requestId);
      } catch (err) {
        console.error("Failed to fetch daily data:", err);
        if (requestId === this.requestSequence) {
          this.isLoading = false;
        }
      }
    },
    GetAllCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(`https://api.disctools.co.uk/api/customers`, config);
      this.allCustomers = response.data.data;
    },
    GetVoicePlusCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.newApiUrl + "/customers", config);
      this.customers = response.data;
    },
    GetCurrencies: async function () {
      if (!this.exchangeRateApiKey) {
        this.currencies = {};
        return;
      }
      const response = await axios.get(`https://v6.exchangerate-api.com/v6/${this.exchangeRateApiKey}/latest/USD`);
      this.currencies = response.data.conversion_rates;
      this.currencies = Object.keys(this.currencies)
        .sort()
        .reduce((result, key) => {
          result[key] = this.currencies[key];
          return result;
        }, {});
    },
    FormatData: async function (requestId = null) {
      this.customer_data = [];
      this.billingData = {
        etgl: { title: "Exel Technology Group", data: [], exportData: [], totals: { bookableSessions: 0, chargeableCalls: 0, fixedLocCalls: 0 } },
        icabbi: { title: "iCabbi", data: [], exportData: [], totals: { bookableSessions: 0, chargeableCalls: 0, fixedLocCalls: 0 } },
      };
      for (const date of this.dailyApiData) {
        for (const [customerId, customerOutcomes] of Object.entries(date.value)) {
          try {
            const foundCustomerRecord = this.allCustomers.find((customer) => {
              return customer.id == customerId;
            });
            if (!foundCustomerRecord) continue;
            if (this.selected_region != "All Regions" && foundCustomerRecord.billing_region != this.selected_region) {
              continue;
            }

            const foundVoicePlusRecord = this.customers.find((customer) => {
              return customer.disctools_id == customerId;
            });
            if (!foundVoicePlusRecord) continue;

            let resellerData = foundCustomerRecord.IsETGLCustomer ? this.billingData["etgl"] : this.billingData["icabbi"];
            let customerData = resellerData.data.find((customerSearch) => {
              return customerSearch.customerInfo.disctools_id == customerId;
            });

            if (!customerData) {
              resellerData.data.push({
                customerInfo: foundVoicePlusRecord,
                paid: { chargeableCalls: 0, bookableSessions: 0, fixedLocCalls: 0 },
                trial: { chargeableCalls: 0, bookableSessions: 0, fixedLocCalls: 0 },
                usage: { recogSeconds: 0, enhancedRecogSeconds: 0, ["google-geocode"]: 0, ["google-autocomplete"]: 0, ["google-placesfromtext"]: 0, ["icabbi-search"]: 0, failover: 0 },
              });
              customerData = resellerData.data[resellerData.data.length - 1];
            }
            const dataDate = dayjs(date.date, "DD-MM-YYYY");
            const trialDays = foundCustomerRecord.IsETGLCustomer ? 6 : 13;
            const trialEndDate = dayjs(foundVoicePlusRecord.added).add(trialDays, "days");
            if (trialEndDate.diff(dataDate, "hours") < 0) {
              for (const [outcomeName, outcomeValue] of Object.entries(customerOutcomes)) {
                if (this.usage_outcomes.includes(outcomeName)) {
                  if (customerData["usage"][outcomeName] == null) customerData["usage"][outcomeName] = 0;
                  customerData["usage"][outcomeName] += outcomeValue;
                  continue;
                }
                if (resellerData.totals[outcomeName] == null) resellerData.totals[outcomeName] = outcomeValue;
                else resellerData.totals[outcomeName] += outcomeValue;
                if (!customerData["paid"]) customerData["paid"] = {};
                if (customerData["paid"][outcomeName] == null) customerData["paid"][outcomeName] = 0;
                customerData["paid"][outcomeName] += outcomeValue;
              }
            } else {
              for (const [outcomeName, outcomeValue] of Object.entries(customerOutcomes)) {
                if (this.usage_outcomes.includes(outcomeName)) {
                  if (customerData["usage"][outcomeName] == null) customerData["usage"][outcomeName] = 0;
                  customerData["usage"][outcomeName] += outcomeValue;
                  continue;
                }
                if (resellerData.totals[outcomeName] == null) resellerData.totals[outcomeName] = outcomeValue;
                else resellerData.totals[outcomeName] += outcomeValue;
                if (!customerData["trial"]) customerData["trial"] = {};
                if (customerData["trial"][outcomeName] == null) customerData["trial"][outcomeName] = 0;
                customerData["trial"][outcomeName] += outcomeValue;
              }
            }
          } catch (err) {
            console.log("CustomerId: " + customerId);
            console.log(err);
          }
        }
      }
      if (requestId !== null && requestId !== this.requestSequence) return;

      this.loaded = true;
      this.isLoading = false;

      this.billingData.etgl.exportData = await this.BuildCSV("etgl");
      this.billingData.icabbi.exportData = await this.BuildCSV("icabbi");
      this.exportData = this.billingData.etgl.exportData.concat(this.billingData.icabbi.exportData);
    },
    UserHasAccess: function (sectionName) {
      for (const group of this.lowercaseGroups) {
        if (group == "icabbi") return true;
        if (sectionName.toLowerCase() == group) {
          return true;
        }
      }
      return false;
    },
    BuildCSV: async function (reseller = null) {
      let builtList = [];
      let data = null;
      if (reseller == "etgl") {
        data = this.billingData["etgl"].data;
      } else if (reseller == "icabbi") {
        data = this.billingData["icabbi"].data;
      }

      if (!Array.isArray(data)) return builtList;

      for (const customer of data) {
        const tmpObj = {};

        if (this.viewingColumnList.includes("customerInfo.uuid")) {
          tmpObj.uid = customer.customerInfo.uuid;
        }
        if (this.viewingColumnList.includes("customerInfo.customer_name")) {
          tmpObj.customer_name = customer.customerInfo.customer_name;
        }

        if (this.viewingColumnList.includes("paid.bookableSessions")) {
          tmpObj.total_calls = (customer.paid.bookableSessions || 0) + (customer.trial.bookableSessions || 0);
        }

        const foundRecord = this.allCustomers.find((c) => c.id == customer.customerInfo.disctools_id);
        tmpObj.subsidiary = foundRecord ? foundRecord.billing_region : "";
        tmpObj.trial_start_date = dayjs(customer.customerInfo.added).format("DD-MM-YYYY");
        const trialDays = foundRecord && foundRecord.IsETGLCustomer ? 6 : 13;
        tmpObj.trial_end_date = dayjs(customer.customerInfo.added).add(trialDays, "days").format("DD-MM-YYYY");

        tmpObj.trial_end_date = dayjs(customer.customerInfo.added).add(trialDays, "days").format("DD-MM-YYYY");

        if (this.viewingColumnList.includes("paid.chargeableCalls")) {
          tmpObj.chargeable_calls = customer.paid.chargeableCalls ? customer.paid.chargeableCalls : 0;
        }
        if (this.viewingColumnList.includes("paid.fixedLocCalls")) {
          tmpObj.fixed_loc_calls = customer.paid.fixedLocCalls ? customer.paid.fixedLocCalls : 0;
        }
        if (this.viewingColumnList.includes("trial.chargeableCalls")) {
          tmpObj.trial_calls = customer.trial.chargeableCalls ? customer.trial.chargeableCalls : 0;
        }
        if (this.viewingColumnList.includes("trial.fixedLocCalls")) {
          tmpObj.trial_fixed_loc_calls = customer.trial.fixedLocCalls ? customer.trial.fixedLocCalls : 0;
        }
        if (this.viewingColumnList.includes("usage.recogSeconds")) {
          tmpObj.recog_seconds = customer.usage.recogSeconds ? customer.usage.recogSeconds : 0;
        }
        if (this.viewingColumnList.includes("usage.enhancedRecogSeconds")) {
          tmpObj.enhanced_recog_seconds = customer.usage.enhancedRecogSeconds ? customer.usage.enhancedRecogSeconds : 0;
        }
        if (this.viewingColumnList.includes("usage.google-geocode")) {
          tmpObj.google_geocode = customer.usage["google-geocode"] ? customer.usage["google-geocode"] : 0;
        }
        if (this.viewingColumnList.includes("usage.google-autocomplete")) {
          tmpObj.google_autocomplete = customer.usage["google-autocomplete"] ? customer.usage["google-autocomplete"] : 0;
        }
        if (this.viewingColumnList.includes("usage.google-placesfromtext")) {
          tmpObj.places_from_text = customer.usage["google-placesfromtext"] ? customer.usage["google-placesfromtext"] : 0;
        }
        if (this.viewingColumnList.includes("usage.icabbi-search")) {
          tmpObj.icabbi_search = customer.usage["icabbi-search"] ? customer.usage["icabbi-search"] : 0;
        }

        builtList.push(tmpObj);
      }
      return builtList;
    },
  },
  filters: {
    commaSeperators: function (x) {
      if (!x) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    secondDivider: function (seconds) {
      let timeInMinutes = 0;
      if (Math.round(seconds / 60) > 0) {
        timeInMinutes = Math.round(seconds / 60);
      } else if (seconds == 0) {
        return "No Data";
      } else {
        return seconds + "S";
      }

      let timeInHours = 0;
      if (Math.round(timeInMinutes / 60) > 0) {
        timeInHours = Math.round(timeInMinutes / 60);
      } else {
        let returnString = timeInMinutes + "M";
        if (seconds % 60 > 0) returnString += " " + (seconds % 60) + "S";
        return returnString;
      }

      let timeInDays = 0;
      if (Math.round(timeInHours / 24) > 0) {
        timeInDays = Math.round(timeInHours / 24);
      } else {
        let returnString = timeInHours + "H";
        if (timeInMinutes % 60 > 0) returnString += " " + (timeInMinutes % 60) + "M";
        return returnString;
      }

      let returnString = timeInDays + "D";
      if (timeInHours % 24 > 0) returnString += " " + (timeInHours % 24) + "H";
      return returnString;
    },
  },
  async mounted() {
    try {
      const getCookie = (name) => {
        const match = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
        return match ? match.substring(name.length + 1) : null;
      };
      const viewingColumnsRaw = getCookie("viewingColumns");
      if (viewingColumnsRaw) this.viewingColumnList = JSON.parse(viewingColumnsRaw);
      const dateRangeRaw = getCookie("dateRange");
      if (dateRangeRaw) this.dateRange = JSON.parse(dateRangeRaw);
      this.$forceUpdate();
    } catch (err) {
      console.error("Failed to restore saved state from cookies:", err);
    }

    try {
      await Promise.all([this.GetAllCustomers(), this.GetVoicePlusCustomers(), this.GetCurrencies()]);
      await this.GetDailyData();
    } catch (err) {
      console.error("Failed to initialize billing data:", err);
      this.isLoading = false;
      this.loaded = false;
    }
  },
  computed: {
    groups: function () {
      if (this.$route && this.$route.params && Array.isArray(this.$route.params.groups)) {
        return this.$route.params.groups;
      }
      return [];
    },
    lowercaseGroups: function () {
      return this.groups.map((group) => String(group).toLowerCase());
    },
    hasIcabbiAccess: function () {
      return this.lowercaseGroups.includes("icabbi");
    },
    Regions: function () {
      let regionList = ["All Regions"];
      this.allCustomers.forEach((customer) => {
        if (!regionList.includes(customer.billing_region)) regionList.push(customer.billing_region);
      });
      return regionList;
    },
    CustomerList: function () {
      let customerList = [];
      this.allCustomers.forEach((customer) => {
        let foundCustomer = this.customers.find((customerSearch) => {
          if (this.lowercaseGroups.includes("etgl") && customerSearch.IsETGLCustomer == 1) {
            return customerSearch.disctools_id == customer.id;
          } else if (this.lowercaseGroups.includes("icabbi")) {
            return customerSearch.disctools_id == customer.id;
          }
          return false;
        });
        if ((customer.billing_region == this.selected_region && foundCustomer) || (this.selected_region == "All Regions" && foundCustomer)) customerList.push(customer);
      });
      customerList.sort((a, b) => {
        if (a.CustomerFriendlyName.toLowerCase() < b.CustomerFriendlyName.toLowerCase()) return -1;
        else if (a.CustomerFriendlyName.toLowerCase() > b.CustomerFriendlyName.toLowerCase()) return 1;
        else return 0;
      });
      customerList.unshift({ id: -1, CustomerFriendlyName: "All Customers" });
      let returnList = customerList.filter((customerSearch) => {
        return customerSearch.CustomerFriendlyName.toLowerCase().includes(this.selected_customer_name.toLowerCase());
      });
      return returnList;
    },
  },
  watch: {
    viewingColumnList: function () {
      document.cookie = `viewingColumns=${JSON.stringify(this.viewingColumnList)};`;
      this.$forceUpdate();
    },
    dateRange: function () {
      document.cookie = `dateRange=${JSON.stringify(this.dateRange)};`;
    },
  },
};
</script>
